var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { mirrorX, strokeWidth } from "apparatus/draw";
import { Gradients } from "apparatus/gradients";
import { interpolate, P, Pivot, R, Segments } from "apparatus/library/common";
import { SVG } from "apparatus/svg";
import { Group, Path, Shape } from "paper";
import { staticImplements } from "types";
export class HeatingMantle {
    render(appearance) {
        let graphic;
        if (appearance.transparency === "none") {
            graphic = SVG.mantle();
        }
        else {
            const mantle = SVG.mantle();
            const mask = mantle.bounds.toShape().toPath();
            let masking;
            if (appearance.transparency === "clip") {
                const whiteout = Shape.Circle(mantle.bounds.topCenter.add(P(0, 30)), 90);
                whiteout.setRadialGradientFill([["#ffffffdd", 0.7], ["#ffffff00", 1.0]]);
                masking = new Group([mask, whiteout]);
                masking.clipped = true;
                graphic = new Group([mantle, masking]);
            }
            else {
                const cutOut = new Path(Segments([[65, 0]], [[65, 30], , [0, 30]], [[0, 90], [30, 0]]));
                mirrorX(cutOut);
                cutOut.position.x += 87;
                cutOut.fillColor = "white";
                cutOut.withStroke(strokeWidth("default"), "#aaaaaa");
                graphic = new Group([mantle, cutOut]);
            }
        }
        return {
            graphic: graphic,
            hitShape: graphic.bounds.toShape(),
            snapping: graphic.placeable(),
        };
    }
}
HeatingMantle.properties = {
    label: "Heating Mantle",
    defaultAppearance: {
        transparency: "none"
    },
    appearanceSpecs: [
        {
            spec: "radio", key: "transparency", label: "Display",
            options: [
                { value: "none", label: "Normal" },
                { value: "clip", label: "Transparent", tier: "boost" },
                { value: "xsection", label: "Cross-section", tier: "boost" },
            ],
            allowSelectingTierLockedOptions: true,
        }
    ],
    isBoostRequired: a => a.transparency === "clip" || a.transparency == "xsection"
};
let SoftHeatingMantle = class SoftHeatingMantle {
    render(appearance) {
        const innerRadius = appearance.diameter / 2;
        const thickness = 20;
        // For small size, should be "= radius", to half radius for larger sizes.
        const height = interpolate(innerRadius, [40, 100], [40, 60]) + thickness;
        const outerRadius = innerRadius + thickness;
        // Pivot = Origin is at the bottom.
        // Shell
        const outerShell1 = new Path.Circle(P(0, -outerRadius), outerRadius);
        const mask = new Path.Rectangle(R(0, 0, 400, height * 0.75, Pivot.BOTTOM_CENTER));
        let outerShell2 = outerShell1.intersect(mask);
        outerShell1.remove();
        outerShell2.remove();
        mask.remove();
        const innerCircleMask = new Path.Circle(P(0, -outerRadius), innerRadius);
        if (appearance.view == "xsection") {
            outerShell2 = outerShell2.subtract(innerCircleMask);
        }
        const outerShell = outerShell2;
        const outerShellShade = outerShell.clone();
        outerShell
            .withStroke("default", "#B59C86")
            .setGradientFill("right-down", Gradients.cylinder("#D6B89E".color(), 3));
        outerShellShade.withGradientFill("down", [["#00000020", 0.0], ["#00000000", 0.3]]);
        const graphic = new Group([outerShell, outerShellShade]);
        // Top part.
        const topPart = new Path.Rectangle(R(0, -height, outerShell.bounds.width + 2, height * 0.3, Pivot.TOP_CENTER), 4)
            .withGradientFill("right", Gradients.cylinder("#E9E7E4".color(), 3))
            .withStroke("default", "#CCCAC8");
        if (appearance.view == "xsection") {
            topPart.remove();
            graphic.addChild(topPart.subtract(innerCircleMask));
        }
        else {
            graphic.addChild(topPart);
        }
        innerCircleMask.remove();
        return {
            graphic,
            hitShape: graphic.rectHitShape(),
            pivot: P(0, 0),
            snapping: [
                { type: "placeable", at: P(0, 0) }
            ]
        };
    }
};
SoftHeatingMantle.properties = {
    label: "Soft Heating Mantle",
    defaultAppearance: {
        diameter: 115,
        view: "normal"
    },
    appearanceSpecs: [
        {
            spec: "slider", key: "diameter", label: "Size",
            min: 80, max: 200
        },
        {
            spec: "radio", key: "view", label: "Display",
            options: [
                { value: "normal", label: "Normal" },
                { value: "xsection", label: "Cross-section" },
            ],
            // allowSelectingTierLockedOptions: true,
        }
    ],
};
SoftHeatingMantle = __decorate([
    staticImplements()
], SoftHeatingMantle);
export { SoftHeatingMantle };
